// extracted by css-extract-rspack-plugin
export default {"container":"container-_zv6db"};